import { Box, Center } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';

type Props = {
  isReviewed: boolean;
  size?: number;
  label?: string;
};

export function ReviewStatusIndicator({ isReviewed, size = 20, label }: Props) {
  const ariaLabel = label ?? (isReviewed ? 'Reviewed' : 'Not reviewed');

  if (isReviewed) {
    return (
      <Center
        role="img"
        aria-label={ariaLabel}
        w={size}
        h={size}
        style={{
          flexShrink: 0,
          borderRadius: '50%',
          backgroundColor: 'var(--mantine-color-white)',
          border: '2px solid var(--mantine-color-success-7)',
        }}
      >
        <IconCheck
          aria-hidden
          size={Math.round(size * 0.6)}
          stroke={3}
          color="var(--mantine-color-success-7)"
        />
      </Center>
    );
  }

  return (
    <Box
      role="img"
      aria-label={ariaLabel}
      w={size}
      h={size}
      style={{
        flexShrink: 0,
        borderRadius: '50%',
        border: '2px solid var(--mantine-color-brand-6)',
      }}
    />
  );
}
